export type Term = {
  id: number
  name: string
  slug: string
  color?: string
}

export type Listing = {
  id: number
  type: 'request' | 'offer'
  icon: 'request' | 'offer'
  start_date: string
  end_date: string
  modified_date: string
  title: string
  issuer_name: string
  author: number
  categories: Term[]
  primary_category: Term
  regions: Term[]
  content: string
  phone: string | null
  email: string | null
  website_url: string | null
  location_address_line_1: string
  location_address_line_2: string | null
  location_address_post_code: string
  location_address_locality: string
  location_address_country: string
  location_latitude: string
  location_longitude: string
  new_badge: boolean
  url: string
}

export const fetchListings = async (
  args: {
    type?: string[]
    category?: string[]
    region?: string[]
  } = {}
): Promise<Listing[]> => {
  // We ignore selected regions when querying for map markers
  const { region, ...rest } = args
  const locale = document.documentElement.getAttribute('lang') ?? 'en-US'
  const queryParams = { ...rest, locale }
  const url =
    '/wp-json/kierfchen/v1/listings' +
    buildListingFilterQueryParams(queryParams)
  const response = await fetch(url)
  const data = await response.json()
  return data
}

export const buildListingFilterQueryParams = (
  args: {
    type?: string[]
    category?: string[]
    region?: string[]
    app_page?: number
  }
): string => {
  const queryParams = new URLSearchParams(
    Object.fromEntries(
      Object.entries(args)
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => [
          key,
          typeof value === 'string' || typeof value === 'number' ? value : value.join(',')
        ])
        .filter(([_, value]) => value !== '')
    )
  )

  const queryParamsString = queryParams.toString()
  return queryParamsString !== '' ? '?' + queryParamsString : ''
}
